import React from 'react';
import Seo from '../components/Seo';
import styled from 'styled-components';
import { Section, Container } from '../shared/ui';

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--brand);
  margin-bottom: 1.5rem;
`;
const Heading = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--brand);
  margin: 2rem 0 0.75rem 0;
`;
const Text = styled.p`
  color: #3a4662;
  line-height: 1.7;
  margin: 0 0 0.75rem 0;
`;
const List = styled.ul`
  color: #3a4662;
  line-height: 1.7;
  margin: 0 0 0.75rem 1.2rem;
`;
const Note = styled.p`
  color: #7a4a00;
  background: #fff7e6;
  border: 1px solid #ffe0a3;
  border-radius: 12px;
  padding: 0.9rem 1.1rem;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
  font-size: 0.95rem;
`;
const Content = styled.div`
  max-width: 760px;
  margin: 0 auto;
`;

const Datenschutz: React.FC = () => (
  <>
    <Seo
      title="Datenschutzerklärung | AP Clean Services"
      description="Datenschutzerklärung der AP Clean Services – Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO."
      path="/datenschutz"
    />
    <Section>
      <Container>
        <Content>
          <Title>Datenschutzerklärung</Title>

          <Note>
            Hinweis: Diese Datenschutzerklärung ist eine anpassbare Vorlage und ersetzt keine
            Rechtsberatung. Bitte lassen Sie die Inhalte vor der Veröffentlichung durch eine
            fachkundige Person (z. B. Datenschutzbeauftragte oder Anwalt) prüfen und an Ihre
            tatsächlichen Verarbeitungsvorgänge anpassen.
          </Note>

          <Heading>1. Verantwortlicher</Heading>
          <Text>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
            AP Clean Services<br />
            Inhaber: Abimanju Premachandran<br />
            Moltkestr. 20, 33330 Gütersloh<br />
            Telefon: <a href="tel:+491729182451">+49 172 9182451</a><br />
            E-Mail: <a href="mailto:info@apcleanservices.de">info@apcleanservices.de</a>
          </Text>

          <Heading>2. Allgemeines zur Datenverarbeitung</Heading>
          <Text>
            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
            Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
            erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers
            oder soweit eine gesetzliche Grundlage die Verarbeitung gestattet.
          </Text>

          <Heading>3. Aufruf der Website (Server-Logfiles)</Heading>
          <Text>
            Beim Besuch unserer Website können durch den Hosting-Anbieter automatisch Informationen
            erfasst werden (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite,
            Browsertyp). Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
            einem sicheren und stabilen Betrieb der Website).
          </Text>

          <Heading>4. Kontaktformular und Kontaktaufnahme</Heading>
          <Text>
            Wenn Sie uns über das Kontaktformular eine Anfrage für eine kostenlose Besichtigung
            senden, verarbeiten wir die von Ihnen angegebenen Daten, um Ihre Anfrage zu bearbeiten.
            Dazu gehören insbesondere:
          </Text>
          <List>
            <li>Firma / Objekt und Ansprechpartner</li>
            <li>Ort</li>
            <li>Telefonnummer und E-Mail-Adresse</li>
            <li>Angaben zu Objektgröße und gewünschten Reinigungstagen</li>
            <li>Ihre Nachricht</li>
          </List>
          <Text>
            Die Übermittlung des Formulars erfolgt an unsere serverseitige Funktion, die Ihre Anfrage
            per E-Mail (SMTP) an uns weiterleitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO
            (Ihre Einwilligung) sowie Art. 6 Abs. 1 lit. b DSGVO (Anbahnung bzw. Durchführung eines
            Vertrags). Die Angabe der als Pflichtfeld gekennzeichneten Daten ist erforderlich, um Ihre
            Anfrage bearbeiten zu können.
          </Text>

          <Heading>5. Kontakt per WhatsApp</Heading>
          <Text>
            Sofern Sie uns über den WhatsApp-Button kontaktieren, gelten zusätzlich die
            Datenschutzbestimmungen des Anbieters WhatsApp Ireland Ltd. Wir haben auf die dortige
            Verarbeitung keinen Einfluss. Nutzen Sie diesen Kanal nur, wenn Sie mit der Verarbeitung
            durch WhatsApp einverstanden sind.
          </Text>

          <Heading>6. Reichweitenmessung und Performance-Analyse (Vercel)</Heading>
          <Text>
            Diese Website wird bei der Vercel Inc., 440 N Barranca Ave #4133, Covina, CA 91723, USA
            gehostet. Wir setzen zwei Dienste dieses Anbieters ein:
          </Text>
          <List>
            <li>
              <b>Vercel Web Analytics</b> zur Reichweitenmessung. Erfasst werden aufgerufene Seiten,
              die verweisende Seite (Referrer), ungefährer Standort auf Länder- bzw. Regionsebene
              sowie Angaben zu Gerätetyp, Betriebssystem und Browser.
            </li>
            <li>
              <b>Vercel Speed Insights</b> zur Messung der Ladegeschwindigkeit. Erfasst werden
              technische Kennzahlen zum Seitenaufbau (sogenannte Core Web Vitals) zusammen mit der
              aufgerufenen Seite.
            </li>
          </List>
          <Text>
            Beide Dienste arbeiten ohne Cookies und ohne Wiedererkennung einzelner Personen über
            mehrere Besuche hinweg. Es werden keine Profile gebildet und keine Daten an Dritte zu
            Werbezwecken weitergegeben. Die IP-Adresse wird nicht gespeichert, sondern lediglich
            transient zur Auslieferung verarbeitet.
          </Text>
          <Text>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse besteht
            darin, die Nutzung unserer Website statistisch auszuwerten und ihre technische
            Leistungsfähigkeit zu verbessern. Sie können dieser Verarbeitung nach Art. 21 DSGVO
            widersprechen; die Kontaktdaten finden Sie unter Ziffer 9. Die Übermittlung in die USA
            erfolgt auf Grundlage der Standardvertragsklauseln der EU-Kommission.
          </Text>

          <Heading>7. Speicherdauer</Heading>
          <Text>
            Wir speichern personenbezogene Daten nur so lange, wie dies für die genannten Zwecke
            erforderlich ist oder gesetzliche Aufbewahrungsfristen dies vorsehen. Anschließend werden
            die Daten gelöscht.
          </Text>

          <Heading>8. Ihre Rechte</Heading>
          <Text>Sie haben nach der DSGVO insbesondere folgende Rechte:</Text>
          <List>
            <li>Auskunft über die verarbeiteten Daten (Art. 15 DSGVO)</li>
            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
            <li>Löschung (Art. 17 DSGVO)</li>
            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
          </List>
          <Text>
            Zudem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die
            Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
          </Text>

          <Heading>9. Kontakt in Datenschutzfragen</Heading>
          <Text>
            Bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten erreichen Sie uns unter:{' '}
            <a href="mailto:info@apcleanservices.de">info@apcleanservices.de</a>
          </Text>
        </Content>
      </Container>
    </Section>
  </>
);

export default Datenschutz;
